/**
 * Build the cache key for state.car.carRateOptionRules.
 *
 * Rate rules depend on the search params (dates, mainly), but the backend's
 * itinerary.uniqueKey can be reused across searches for the same car/vendor/rate
 * with different dates. Keying the cache by uniqueKey alone leads to a stale-data
 * bug: opening "View Details" on a car after changing the search dates returns
 * the previously cached rate rules (e.g. numDays = 9 after a 10-day search).
 *
 * Including pickUpDateTime + dropOffDateTime in the key gives each search its
 * own entry while still letting us reuse the cache within a single search
 * session.
 */
const getCarRateRulesCacheKey = (itinerary) => {
  if (!itinerary || !itinerary.uniqueKey) return null;
  return `${itinerary.uniqueKey}__${itinerary.pickUpDateTime || ''}__${itinerary.dropOffDateTime || ''}`;
};

export default getCarRateRulesCacheKey;
